import React from "react";
import {selectStore} from "../../../../../store/selector";
import {useSelector} from "react-redux";
import {Alert} from "antd";
import {useTranslation} from "react-i18next";

export const EntrantAlertComponent = () => {
  const {t} = useTranslation(['executorAdmissionSteps', 'common'])

  const {admission: {arrayOfSpecialities}} = useSelector(selectStore);

  const alertText =
    <>
      <p>{t('executorAdmissionSteps:selectedCollegeComponent.selectedSpecialty')}: <span>{arrayOfSpecialities.data[0].speciality.caption}</span></p>
      <p>{t('executorAdmissionSteps:selectedCollegeComponent.selectedCollege')}: <span>{arrayOfSpecialities.data[0].college.name}</span></p>
      <p>{t('executorAdmissionSteps:selectedCollegeComponent.selectedType')}: <span>{arrayOfSpecialities.data[0].qualification.caption}</span></p>
      <p>{t('executorAdmissionSteps:stepOne.specialtyForm.language')}: <span>{arrayOfSpecialities.data[0].language_of_education === 1 ? t("common:kz") : arrayOfSpecialities.data[0].language_of_education === 2 ? t("common:ru") : arrayOfSpecialities.data[0].language_of_education === 3 ? 'Английский' : 'Что-то не то с языком'}</span></p>
    </>

  return <Alert message={alertText} type="success"/>
}